import { render, staticRenderFns } from "./shorturl-list.vue?vue&type=template&id=25c4798e&scoped=true&"
import script from "./shorturl-list.vue?vue&type=script&lang=js&"
export * from "./shorturl-list.vue?vue&type=script&lang=js&"
import style0 from "./shorturl-list.vue?vue&type=style&index=0&id=25c4798e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25c4798e",
  null
  
)

export default component.exports